var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{staticClass:"mt-6 mb-8",attrs:{"type":"donut","height":_vm.height,"options":_vm.options,"series":_vm.series},on:{"dataPointSelection":_vm.emitClickSection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }